import React from "react";
import "./App.css";
import { Admin, CustomRoutes, fetchUtils, Layout, Resource } from "react-admin";
import dataProvider from "ra-data-simple-rest";
import { maskedDocumentVariant } from "./util/documentSearch";
import { AppErrorPage } from "./components/AppErrorPage";
import authProvider from "./AuthProvider";
import { AppSidebarMenu } from "./components/AppMenus";
import { AppNavbar } from "./components/AppNavbar";
import { UserList } from "./ra-components/users/UserList";
import { UserEdit } from "./ra-components/users/UserEdit";
import { UserShow } from "./ra-components/users/UserShow";
import { UserCreate } from "./ra-components/users/UserCreate";
import LoginPage from "./components/pages/Login";
import { TransactionsCreate } from "./ra-components/transactions/TransactionsCreate";
import { TransactionsShow } from "./ra-components/transactions/TransactionsShow";
import { TransactionsEdit } from "./ra-components/transactions/TransactionsEdit";
import { TransactionsList } from "./ra-components/transactions/TransactionsList";
import { FeedbacksCreate } from "./ra-components/feedbacks/FeedbacksCreate";
import { FeedbacksShow } from "./ra-components/feedbacks/FeedbacksShow";
import { FeedbacksEdit } from "./ra-components/feedbacks/FeedbacksEdit";
import { FeedbacksList } from "./ra-components/feedbacks/FeedbacksList";
import { UserRolesList } from "./ra-components/user-roles/UserRolesList";
import { UserRolesEdit } from "./ra-components/user-roles/UserRolesEdit";
import { UserRolesCreate } from "./ra-components/user-roles/UserRolesCreate";
import { UserRolesShow } from "./ra-components/user-roles/UserRolesShow";
import { DashboardPage } from "./components/pages/DashboardPage";
import SubscriptionPage from "./components/pages/iugu/SubscriptionPage";
import IuguCustomersPage from "./components/pages/iugu/IuguCustomersPage";
import IuguPlanosPage from "./components/pages/iugu/IuguPlanosPage";
import IuguCreatePlanosPage from "./components/pages/iugu/IuguCreatePlanosPage";
import { Route } from "react-router-dom";
import { ApiPage } from "./components/pages/ApiPage";
import { EducationalInstitutionList } from "./ra-components/educational-institutions/EducationalInstitutionList";
import { EducationalInstitutionEdit } from "./ra-components/educational-institutions/EducationalInstitutionEdit";
import { EducationalInstitutionShow } from "./ra-components/educational-institutions/EducationalInstitutionShow";
import { EducationalInstitutionCreate } from "./ra-components/educational-institutions/EducationalInstitutionCreate";
import { UserCategoryList } from "./ra-components/user-categories/UserCategoryList";
import { UserCategoryEdit } from "./ra-components/user-categories/UserCategoryEdit";
import { UserCategoryShow } from "./ra-components/user-categories/UserCategoryShow";
import { UserCategoryCreate } from "./ra-components/user-categories/UserCategoryCreate";
import { TechDivisionList } from "./ra-components/technical-divisions/TechDivisionList";
import { TechDivisionEdit } from "./ra-components/technical-divisions/TechDivisionEdit";
import { TechDivisionShow } from "./ra-components/technical-divisions/TechDivisionShow";
import { TechDivisionCreate } from "./ra-components/technical-divisions/TechDivisionCreate";
import { GraduationList } from "./ra-components/graduations/GraduationList";
import { GraduationEdit } from "./ra-components/graduations/GraduationEdit";
import { GraduationShow } from "./ra-components/graduations/GraduationShow";
import { GraduationCreate } from "./ra-components/graduations/GraduationCreate";
import { TransactionCategoryList } from "./ra-components/transaction-categories/TransactionCategoryList";
import { TransactionCategoryEdit } from "./ra-components/transaction-categories/TransactionCategoryEdit";
import { TransactionCategoryShow } from "./ra-components/transaction-categories/TransactionCategoryShow";
import { TransactionCategoryCreate } from "./ra-components/transaction-categories/TransactionCategoryCreate";
import englishMessages from "ra-language-english";
import polyglotI18nProvider from "ra-i18n-polyglot";
import IuguMyBillsPage from "./components/pages/iugu/IuguMyBillsPage";
import IuguMySubsPage from "./components/pages/iugu/IuguMySubsPage";
import { ProductList } from "./ra-components/products/ProductList";
import { ProductEdit } from "./ra-components/products/ProductEdit";
import { ProductCreate } from "./ra-components/products/ProductCreate";
import { ProductShow } from "./ra-components/products/ProductShow";
import IuguCreateBillPage from "./components/pages/iugu/IuguCreateBill";
import IuguCreateSubscriptionPage from "./components/pages/iugu/IuguCreateSubscription";
import { UserRoleStatusList } from "./ra-components/user-role-status/UserRoleStatusList";
import { UserRoleStatusEdit } from "./ra-components/user-role-status/UserRoleStatusEdit";
import { UserRoleStatusShow } from "./ra-components/user-role-status/UserRoleStatusShow";
import { UserRoleStatusCreate } from "./ra-components/user-role-status/UserRoleStatusCreate";
import { UserPositionRoleList } from "./ra-components/user-position-roles/UserPositionRoleList";
import { UserPositionRoleEdit } from "./ra-components/user-position-roles/UserPositionRoleEdit";
import { UserPositionRoleShow } from "./ra-components/user-position-roles/UserPositionRoleShow";
import { UserPositionRoleCreate } from "./ra-components/user-position-roles/UserPositionRoleCreate";
import { UserElectionList } from "./ra-components/user-elections/UserElectionList";
import { UserElectionEdit } from "./ra-components/user-elections/UserElectionEdit";
import { UserElectionShow } from "./ra-components/user-elections/UserElectionShow";
import { UserElectionCreate } from "./ra-components/user-elections/UserElectionCreate";
import { RegisterPageV2 } from "./components/pages/RegisterPageV2";
import { RegisterPageSuccess } from "./components/pages/RegisterPageSuccess";
import { RegisterDisabledPage } from "./components/pages/RegisterDisabledPage";
import { PUBLIC_REGISTRATION_ENABLED } from "./data/features";
import { RecoveryPasswordPage } from "./components/pages/RecoveryPasswordPage";
import { MailTemplateList } from "./ra-components/mail-templates/MailTemplateList";
import { MailTemplateEdit } from "./ra-components/mail-templates/MailTemplateEdit";
import { MailTemplateShow } from "./ra-components/mail-templates/MailTemplateShow";
import { MailTemplateCreate } from "./ra-components/mail-templates/MailTemplateCreate";
import { OrphanedUsersList } from "./ra-components/orphaned-users/OrphanedUsersList";
import { OrphanedUsersEdit } from "./ra-components/orphaned-users/OrphanedUsersEdit";
import { OrphanedUsersShow } from "./ra-components/orphaned-users/OrphanedUsersShow";
import { OrphanedUsersCreate } from "./ra-components/orphaned-users/OrphanedUsersCreate";
import { IuguInvoicesPage } from "./components/pages/iugu/IuguInvoicesPage";
import { SystemSettingList } from "./ra-components/system-settings/SystemSettingList";
import { SystemSettingEdit } from "./ra-components/system-settings/SystemSettingEdit";
import { SystemSettingShow } from "./ra-components/system-settings/SystemSettingShow";
import { SystemSettingCreate } from "./ra-components/system-settings/SystemSettingCreate";
import { determineUserReadableRole } from "./ra-components/users/UserUtils";
import { themeClean } from "./data/theme";
import { AppNotification } from "./components/AppNotification";
import { alterPortuguese } from "./data/i18n";
import WpLogin from "./components/pages/WpLogin";
import IuguClientIssueBill from "./components/pages/iugu/IuguClientIssueBill";

// console.log("lang ra", englishMessages);
const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "pt-br" ? alterPortuguese : englishMessages),
  "pt-br",
  [{ locale: "pt-br", name: "Português" }],
  {
    allowMissing: true,
  }
);

const isMobile = () => {
  if (window.outerWidth < 720) {
    localStorage.setItem("isMobile", "true");
  } else {
    localStorage.setItem("isMobile", "false");
  }
};

isMobile();
const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const auth = localStorage.getItem("auth");
  const authJson = auth ? JSON.parse(auth) : auth;
  if (auth) {
    const token = authJson.access_token;
    options.headers.set("Authorization", `Bearer ${token}`);
    const { status, headers, body, json } = await fetchUtils.fetchJson(
      url,
      options
    );
    return { status, headers, body, json };
  } else {
    const { status, headers, body, json } = await fetchUtils.fetchJson(
      url,
      options
    );
    return { status, headers, body, json };
  }
};

// Componente de layout com identidade ESTÁVEL (definido fora do render):
// recriar essas funções a cada render faz o React desmontar e remontar
// o header/menu a cada navegação, causando o "piscar" da barra superior.
const AppLayout = (props) => (
  <Layout
    className={`mainLayout ${
      localStorage.getItem("isMobile") === "true" ? "isMobile" : "isNotMobile"
    }`}
    {...props}
    appBar={AppNavbar}
    menu={AppSidebarMenu}
    appBarAlwaysOn
    // Página de erro própria no lugar da padrão do react-admin (que
    // exibe links de desenvolvedor e texto com erro de português)
    error={AppErrorPage}
  />
);

export default class App extends React.Component {
  constructor(props) {
    super(props);
    const baseDataProvider = dataProvider(
      process.env.REACT_APP_API_PATH,
      httpClient
    );
    // Busca por CPF/CNPJ digitado sem pontuação: a base grava o documento
    // com máscara, então a busca literal por dígitos volta vazia. Quando
    // isso acontece e o termo é um documento completo (11/14 dígitos), a
    // consulta é repetida com o termo mascarado. Vale para toda tela que
    // usa o filtro mailName (lista de Sócios, autocompletes, link "Ver
    // cadastro do sócio" de Contatos).
    this.dataProvider = {
      ...baseDataProvider,
      getList: (resource, params) =>
        baseDataProvider.getList(resource, params).then((res) => {
          const term = params?.filter?.mailName;
          if ((res?.total ?? 0) > 0 || typeof term !== "string") return res;
          const masked = maskedDocumentVariant(term);
          if (!masked) return res;
          return baseDataProvider.getList(resource, {
            ...params,
            filter: { ...params.filter, mailName: masked },
          });
        }),
    };
  }
  render() {
    const roles = localStorage.getItem("roles");

    // console.log("loaded", localStorage.getItem("auth"));
    return (
      <Admin
        layout={AppLayout}
        loginPage={LoginPage}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        dataProvider={this.dataProvider}
        theme={themeClean}
        notification={AppNotification}
        disableTelemetry
      >
        {(determineUserReadableRole(roles) === "admin" ||
          determineUserReadableRole(roles) === "finance" ||
          determineUserReadableRole(roles) === "secretary" ||
          determineUserReadableRole(roles) === "comms") && (
          <>
            <CustomRoutes>
              <Route path="/profile" component={""} />
              {(determineUserReadableRole(roles) === "admin" ||
                determineUserReadableRole(roles) === "finance") && (
                <>
                  <Route
                    path="/dashboard"
                    element={<DashboardPage props={this} />}
                  />
                  <Route path="/subscriptions" element={<SubscriptionPage />} />
                  <Route
                    path="/subscriptions/create"
                    element={<IuguCreateSubscriptionPage />}
                  />
                  <Route
                    path="/iugu-invoices/create"
                    element={<IuguCreateBillPage />}
                  />
                  <Route path="/iugu-planos" element={<IuguPlanosPage />} />
                  <Route
                    path="/iugu-planos/create"
                    element={<IuguCreatePlanosPage />}
                  />

                  <Route
                    path="/iugu-customers"
                    element={<IuguCustomersPage />}
                  />
                  <Route path="/iugu-invoices" element={<IuguInvoicesPage />} />
                </>
              )}
              {determineUserReadableRole(roles) === "admin" && (
                <Route path="/api" element={<ApiPage />} />
              )}
            </CustomRoutes>
            <Resource
              name="users/crud"
              options={{ label: "Sócios" }}
              {...((determineUserReadableRole(roles) === "admin" ||
                determineUserReadableRole(roles) === "finance" ||
                determineUserReadableRole(roles) === "secretary" ||
                determineUserReadableRole(roles) === "comms") && {
                list: UserList,
              })}
              {...(determineUserReadableRole(roles) === "admin" && {
                edit: UserEdit,
                create: UserCreate,
              })}
              show={UserShow}
              // edit={UserEdit}
              // list={UserList}
              // create={UserCreate}
            />

            {determineUserReadableRole(roles) === "admin" && (
              <>
                <Resource
                  name="orphaned-users/crud"
                  options={{ label: "Membros Órfãos" }}
                  list={OrphanedUsersList}
                  edit={OrphanedUsersEdit}
                  create={OrphanedUsersCreate}
                  show={OrphanedUsersShow}
                />
                <Resource
                  name="mail-templates/crud"
                  options={{ label: "Templates de E-mail" }}
                  list={MailTemplateList}
                  edit={MailTemplateEdit}
                  show={MailTemplateShow}
                  create={MailTemplateCreate}
                />
                <Resource
                  name="user-elections/crud"
                  options={{ label: "Eleições" }}
                  list={UserElectionList}
                  create={UserElectionCreate}
                  edit={UserElectionEdit}
                  show={UserElectionShow}
                />
                <Resource
                  name="user-position-roles/crud"
                  options={{ label: "Cargos e Funções" }}
                  list={UserPositionRoleList}
                  edit={UserPositionRoleEdit}
                  create={UserPositionRoleCreate}
                  show={UserPositionRoleShow}
                />
                <Resource
                  name="user-role-status/crud"
                  options={{ label: "Status de Cargos e Funções" }}
                  list={UserRoleStatusList}
                  edit={UserRoleStatusEdit}
                  show={UserRoleStatusShow}
                  create={UserRoleStatusCreate}
                />
                <Resource
                  name="user-roles/crud"
                  options={{ label: "Regras de Usuário" }}
                  list={UserRolesList}
                  edit={UserRolesEdit}
                  show={UserRolesShow}
                  create={UserRolesCreate}
                />
                <Resource
                  name="technical-divisions/crud"
                  options={{ label: "Divisões Técnicas" }}
                  list={TechDivisionList}
                  edit={TechDivisionEdit}
                  show={TechDivisionShow}
                  create={TechDivisionCreate}
                />
                <Resource
                  name="user-categories/crud"
                  options={{ label: "Categorias de Sócios" }}
                  list={UserCategoryList}
                  edit={UserCategoryEdit}
                  show={UserCategoryShow}
                  create={UserCategoryCreate}
                />
                <Resource
                  name="graduations/crud"
                  options={{ label: "Formações" }}
                  list={GraduationList}
                  edit={GraduationEdit}
                  show={GraduationShow}
                  create={GraduationCreate}
                />
                <Resource
                  name="educational-institutions/crud"
                  options={{ label: "Instituições de Ensino" }}
                  list={EducationalInstitutionList}
                  edit={EducationalInstitutionEdit}
                  show={EducationalInstitutionShow}
                  create={EducationalInstitutionCreate}
                />
                <Resource
                  name="products/crud"
                  options={{ label: "Itens de Cobrança" }}
                  list={ProductList}
                  edit={ProductEdit}
                  show={ProductShow}
                  create={ProductCreate}
                />{" "}
                <Resource
                  name="system-settings/crud"
                  options={{ label: "Configurações de Sistema" }}
                  list={SystemSettingList}
                  edit={SystemSettingEdit}
                  show={SystemSettingShow}
                  create={SystemSettingCreate}
                />
              </>
            )}

            <Resource
              name="feedbacks/crud"
              options={{ label: "Contatos" }}
              list={FeedbacksList}
              edit={FeedbacksEdit}
              show={FeedbacksShow}
              create={FeedbacksCreate}
            />
            {(determineUserReadableRole(roles) === "admin" ||
              determineUserReadableRole(roles) === "secretary" ||
              determineUserReadableRole(roles) === "finance") && (
              <>
                <Resource
                  name="transaction-categories/crud"
                  options={{ label: "Categorias de Transações" }}
                  list={TransactionCategoryList}
                  edit={TransactionCategoryEdit}
                  show={TransactionCategoryShow}
                  create={TransactionCategoryCreate}
                />
                <Resource
                  name="transactions/crud"
                  options={{ label: "Transações" }}
                  list={<TransactionsList dataProvider={this.dataProvider} />}
                  edit={TransactionsEdit}
                  show={TransactionsShow}
                  create={TransactionsCreate}
                />
              </>
            )}
          </>
        )}
        {determineUserReadableRole(roles) === "user" && (
          <>
            <CustomRoutes>
              <Route path="/profile" component={""} />
              <Route
                path="/my-invoices"
                element={<IuguMyBillsPage props={this} />}
              />
              <Route
                path="/my-subscriptions"
                element={<IuguMySubsPage props={this} />}
              />
              {/* <Route
                path="/dashboard"
                element={<DashboardPage props={this} />}
              /> */}
            </CustomRoutes>
            <Resource
              name="users/crud"
              options={{ label: "Sócios" }}
              // list={UserList}
              edit={UserEdit}
              show={UserShow}
              // create={UserCreate}
            />

            <Resource
              name="feedbacks/crud"
              options={{ label: "Contatos" }}
              // list={FeedbacksList}
              // edit={FeedbacksEdit}
              // show={FeedbacksShow}
              create={FeedbacksCreate}
            />
          </>
        )}
        <>
          {/* Páginas internas: mantêm o app shell (menu + navbar) */}
          <CustomRoutes>
            <Route path="/my-invoices/new" element={<IuguClientIssueBill />} />
            <Route path="/wp-login" element={<WpLogin />} />
          </CustomRoutes>
          {/* Telas públicas de acesso (login/cadastro/recuperar senha):
              renderizadas SEM o menu lateral do painel — ele não faz
              sentido para quem ainda não entrou e vazava um menu de
              "Login/Cadastro" nessas telas */}
          <CustomRoutes noLayout>
            {/* Cadastro público: aviso no lugar do formulário enquanto
                estiver desativado (data/features.ts) */}
            <Route
              path="/register"
              element={
                PUBLIC_REGISTRATION_ENABLED ? (
                  <RegisterPageV2 />
                ) : (
                  <RegisterDisabledPage />
                )
              }
            />
            <Route path="/register/success" element={<RegisterPageSuccess />} />
            <Route
              path="/account-recovery"
              element={<RecoveryPasswordPage />}
            />
            <Route
              path="/account-recovery/:token/*"
              element={<RecoveryPasswordPage />}
            />
          </CustomRoutes>
          <Resource
            name="feedbacks/crud"
            options={{ label: "Contatos" }}
            list={FeedbacksList}
            edit={FeedbacksEdit}
            show={FeedbacksShow}
            create={FeedbacksCreate}
          />
        </>
      </Admin>
    );
  }
}
